var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.4C1 2.07 2.07 1 3.4 1H9.1C9.74 1 10.35 1.25 10.8 1.7L18.3 9.2C19.24 10.14 19.24 11.66 18.3 12.6L12.6 18.3C11.66 19.24 10.14 19.24 9.2 18.3L1.7 10.8C1.25 10.35 1 9.74 1 9.1V3.4Z",
    fill: "#4A4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.6,
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagfill);
export default __webpack_public_path__ + "static/media/tag.fill.df870cd0146b8b75574d3d5088262393.svg";
export { ForwardRef as ReactComponent };